import React, { useState } from 'react';
import { Lightning, Trophy } from '@phosphor-icons/react';
import ChallengePage from './ChallengePage';
import WeeklyChallengePage from './WeeklyChallengePage';

const ChallengesWrapper = () => {
  const [tab, setTab] = useState('buddy');

  return (
    <div className="space-y-6" data-testid="challenges-wrapper">
      {/* Tab Switcher */}
      <div className="flex gap-2 bg-[#F5F5F4] p-1.5 rounded-xl w-fit">
        <button
          onClick={() => setTab('buddy')}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium transition-all ${
            tab === 'buddy'
              ? 'bg-white text-[#AB1C24] shadow-sm'
              : 'text-[#78716C] hover:text-[#292524]'
          }`}
          data-testid="tab-buddy-challenges"
        >
          <Lightning size={18} weight={tab === 'buddy' ? 'fill' : 'regular'} />
          Buddy-Challenges
        </button>
        <button
          onClick={() => setTab('weekly')}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium transition-all ${
            tab === 'weekly'
              ? 'bg-white text-[#AB1C24] shadow-sm'
              : 'text-[#78716C] hover:text-[#292524]'
          }`}
          data-testid="tab-weekly-challenge"
        >
          <Trophy size={18} weight={tab === 'weekly' ? 'fill' : 'regular'} />
          Wochen-Challenge
        </button>
      </div>

      {/* Content */}
      {tab === 'buddy' ? <ChallengePage /> : <WeeklyChallengePage />}
    </div>
  );
};

export default ChallengesWrapper;
